import { styled } from '../../../base';

export const StepConnector = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: 20,
    insetInlineStart: 'calc(-50% + 20px)',
    insetInlineEnd: 'calc(50% + 20px)',
    height: 2,
    backgroundColor: theme.palette.primary.main,
    zIndex: 1,
}));
